import React, { memo, useCallback } from "react";

import { LottieAnimation } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

import { CALLOUTS_BANNER_LOTTIE_PROPS } from "@dineout-payment-success-ui/constants/CalloutsBanner";
import { getCalloutsBannerLottieUrl } from "@dineout-payment-success-ui/helpers/CalloutsBanner";
import { ICalloutsBannerContentProps } from "@dineout-payment-success-ui/interfaces";
import { SUCCESS_PAGE_TEST_IDS } from "@swiggy-private/payment-test-ids";

import { CalloutsBannerContentWrapper, CalloutsBannerLottieWrapper } from "./styles";

const CalloutsBannerContent: React.FC<ICalloutsBannerContentProps> = ({ item, onItemClick }) => {
    const getLottieUrl = useCallback(() => {
        if (isEmpty(item) || isEmpty(item.itemLottieId)) {
            return "";
        }

        return getCalloutsBannerLottieUrl(item.itemLottieId);
    }, [item]);

    const handleClick = useCallback(() => {
        if (isEmpty(item) || !item.clickable) {
            return;
        }

        onItemClick(item);
    }, [item, onItemClick]);

    if (isEmpty(item)) {
        return null;
    }

    const lottieUrl = getLottieUrl();

    if (isEmpty(lottieUrl)) {
        return null;
    }

    return (
        <CalloutsBannerContentWrapper
            isClickable={item.clickable}
            onClick={handleClick}
            data-testid={SUCCESS_PAGE_TEST_IDS.CALLOUTS_BANNER_CONTENT}
            data-banner-id={item.id}
        >
            <CalloutsBannerLottieWrapper>
                <LottieAnimation
                    {...CALLOUTS_BANNER_LOTTIE_PROPS}
                    fileName={lottieUrl}
                    visible
                    playLottie
                    preserveAspect="xMidYMid meet"
                />
            </CalloutsBannerLottieWrapper>
        </CalloutsBannerContentWrapper>
    );
};

export default memo(CalloutsBannerContent);
